import { User } from "types/user";
import { api } from "./api";
import { clearRegistrationUser } from "utils/fns";

// const generate = (category:string, length:number) => {
//  return Array.from({ length: length }, (_, i) => ({
//   _id: `${category}_${Date.now()}_${600 + i}`,
//   documento: [
//     {
//       file: `https://example.com/documento_${i}.pdf`,
//       nameFile: `Documento_${i}.pdf`,
//       type: "application/pdf"
//     }
//   ],
//   dt_aceite: "2025-02-16T12:00:00Z",
//   rawPlayer: `player${i}`,
//   inscricao_mat: `MAT${456789 + i}`,
//   inscricao_name: `Usuário ${i}`,
//   description: `Descrição do evento ${i}`,
//   id_inscricao: `INS${789456 + i}`,
//   owner: `USR${123456 + i}`,
//   owner_name: `Empresa ${i}`,
//   title: `Evento ${i} ${category}`,
//   prefixo: 100 + i,
//   id_realizacao: `REAL${123456 + i}`,
//   categoria: category,
//   evaluation: i % 2 === 0 ? "Avaliação pendente" : "Avaliação concluída"
// }));
// }

// function getRandomFloat(min:number, max:number) {
//   return Math.random() * (max - min) + min;
// }

const getEvaluationRealizations = async (
  prefix: any,
  isMad: boolean,
  user: User,
  isStepTwo: boolean
) => {
  try {
    const { data } = await api.post(
      "/find/realizationforstep",
      {},
      {
        headers: { Range: `items=0-500` },
      }
    );

    const { data: response } = await api.post("/find/realizationByPrefix", {
      prefixo: user.detail.prefixo,
    });

    if (!Array.isArray(data)) {
      return [];
    } else {
      const categories = Array.from(
        new Set(data.map((item) => item.categoria))
      );
      const grouped = categories.map((category) => {
        let realizations = [];
        if (isStepTwo) {
          realizations = data.filter((item) => item.categoria === category);
        } else {
          if (isMad) {
            realizations = data.filter(
              (item) => item.mad === true && item.categoria === category
            );
          } else {
            if (["UE"].includes(prefix)) {
              if (
                ![8010, 8033, 8042, 8063, 8069, 8166, 8468, 9597].includes(
                  user.detail.prefixo
                )
              ) {
                realizations = data.filter(
                  (item) =>
                    item.pref_diretoria === user.detail.pref_diretoria &&
                    ![8010, 8033, 8042, 8063, 8069, 8166, 8468, 9597].includes(
                      item.prefixo
                    ) &&
                    item.categoria === category &&
                    item.mad !== true &&
                    item.ro.slice(-2) === prefix
                );
              } else if (
                [8010, 8033, 8042, 8063, 8069, 8166, 8468, 9597].includes(
                  user.detail.prefixo
                )
              ) {
                realizations = data.filter(
                  (item) =>
                    item.prefixo === user.detail.prefixo &&
                    item.categoria === category &&
                    item.mad !== true &&
                    item.ro.slice(-2) === prefix
                );
              }
            } else if (["UA", "UT", "CA"].includes(prefix)) {
              if (response[0].qtdRealizByPrefix > 0) {
                realizations = data.filter(
                  (item) =>
                    item.pref_diretoria === user.detail.pref_diretoria &&
                    item.categoria === category &&
                    item.mad !== true &&
                    item.ro.slice(-2) === prefix
                );
              }
            } else if (
              user.detail.cod_funcao === 610 &&
              user.detail.ro === ""
            ) {
              realizations = data.filter(
                (item) =>
                  item.prefixo === user.detail.prefixo &&
                  item.categoria === category &&
                  item.mad !== true
              );
            }
          }
        }
        return {
          categoryName: category,
          realizations: realizations,
        };
      });

      return grouped;
    }
  } catch (e) {
    throw e;
  }
};


const getEvaluatorRealizations = async(user: User) =>{
  try{
    let query = [
      {
        $match:{}
      },
      {
          $unwind: "$realizations"
      },
      {
          $replaceRoot: {
              newRoot: "$realizations"
          }
      }
    ]

    let match = {};

    match = { step: 2 };

    query.unshift({$match:match})

    const {data} = await api.post('/database/realizacao_avaliacao__c/aggregate',query);

    if (!Array.isArray(data)) {
      return [];
    } else {
      const categories = Array.from(
        new Set(data.map((item) => item.categoria))
      );

       const grouped = categories.map((category) => {

       const uniqueRealizations = Array.from(
        new Map(
          data
            .filter((item) => item.categoria === category)
            .map((realization) => [realization._id, realization]) // Usa `_id` como chave única
        ).values()
      );

        return {
          categoryName: category,
          realizations: uniqueRealizations,
        };
       })

       console.log(grouped);

       return grouped
    }
  }catch(e){
    throw e;
  }
}

const verifyTasksByPrefixo = async (user: User) => {
  try {
    let query = [
      {
        $facet: {
          matches: [{ $match: { prefixo: user.detail.prefixo } }, { $limit: 1 }],
        },
      },
      {
        $project: {
          exists: {
            $gt: [{ $size: "$matches" }, 0],
          },
        },
      },
    ];

    const { data } = await api.post("/database/bb_task__c/aggregate", query);

    return data
  } catch (e) {
    throw e;
  }
};

const getEvaluationVp = async (vpId: string) => {
  try {
    const { data } = await api.post("/find/realizationByVP", { _id: vpId });

    if (!Array.isArray(data)) {
      return [];
    } else {
      const categories = Array.from(
        new Set(data.map((item) => item.categoria))
      );
      const grouped = categories.map((category) => {
        const realizations = data.filter((item) => item.categoria === category);
        return {
          categoryName: category,
          realizations: realizations,
        };
      });

      return grouped;
    }
  } catch (error: any) {
    throw error;
  }
};

const getEvaluatedRealizations = async (player: User) => {
  try {
    let playerId = player._id;
    if(player.detail.acessor && player.detail.acessor.vp){
      playerId = player.detail.acessor.vp.matricula;
    }
    

    let playerData = clearRegistrationUser(playerId);

    const query = [
      {
        $match: {
          player: playerData,
        },
      },
    ];
    const { data } = await api.post(
      "/database/realizacao_avaliacao__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return [];
    } else {
      console.log(data);
      return data[0];
    }
  } catch (e) {
    throw e;
  }
};



const getEvaluatedRealizationsDirector = async (player: User, isGrouped?:boolean) => {
  try {
    let playerData = clearRegistrationUser(player._id);

    const query = [
      {
        $match: {
          player: playerData,
          step:3
        },
      },
    ];
    const { data } = await api.post(
      "/database/realizacao_avaliacao__c/aggregate",
      query
    );

    if (!Array.isArray(data)) {
      return [];
    } else {
      if(isGrouped){
        if(data.length === 0) return [];
        let newData = data[0].realizations;
        const categories = Array.from(
        new Set(newData.map((item:any) => item.categoria))
      );

       const grouped = categories.map((category) => {
        const realizations = newData.filter((item:any) => item.categoria === category);
        return {
          categoryName: category,
          realizations: realizations,
        };
       })
       console.log(grouped);
       return grouped
      }else{
        return data[0];
      }
    }
  } catch (e) {
    throw e;
  }
};

const newEvaluateRealization = async (body: any) => {
  try {
    const { data } = await api.post(`/database/realizacao_avaliacao__c`, body);
    return data;
  } catch (e) {
    throw e;
  }
};

export {
  getEvaluationRealizations,
  newEvaluateRealization,
  getEvaluatedRealizations,
  getEvaluationVp,
  getEvaluatorRealizations,
  getEvaluatedRealizationsDirector,
  verifyTasksByPrefixo,
};
